import { useQuery } from "react-query";
import { fetchMarketSection } from "./fetchMarketSection";

const useTodayDealLimit = () => {
  const { data, isLoading, isError } = useQuery("todayDealLimit", async () => {
    const result = await fetchMarketSection(
      `${process.env.REACT_APP_SERVER_URL}/product/category/todays-deals`
    );
    return result || { todaysDealProducts: [] };
  });

  return { data, isLoading, isError };
};

export default useTodayDealLimit;
